import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import type { BillingPlans } from '../../../api/types';
import { useAuth } from '../../../app/providers/useAuth';
import { fetchBillingPlans } from '../api/billingApi';

// PARA-131 (AC-3) — прайс в Stars. Цена, валюта и период приходят только
// отсюда, во фронте не хардкодятся.
export function useBillingPlans(): UseQueryResult<BillingPlans> {
  const { user } = useAuth();

  return useQuery({
    queryKey: ['billing', 'plans'],
    queryFn: fetchBillingPlans,
    enabled: user !== null,
  });
}
